import React from 'react';
import PropTypes from 'prop-types';
import { ReadMoreText } from '../../elements-container/read-more-text-toggle';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Stereo } from '../../icons';
import { eventFaqDefinition, miscEventFaqDefinitions, category_labels } from '../data/eventFaqDefinition';

const AVMusicExpanded = ({ faqData = {}, availableEquipment, intl }) => {
  const label = <FormattedMessage
    id={category_labels.av_music.id}
    defaultMessage={category_labels.av_music.defaultMessage}
  />;
  return (
    <div className="EventFAQ">
      <div className="flex middle">
        <Stereo height={24} width={24} className="margin-sm-right" />
        <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
      </div>
      <div className="margin-lg-bottom section-indent event-faq-section ">
        <div className="faq-label heavier margin-md-bottom">
          {intl.formatMessage(miscEventFaqDefinitions.available_av_equipment)}
        </div>
        {availableEquipment.map((equipment, key) => (
          <div className="faq-body flex margin-md-bottom" key={key}>
            <div className="flex-basis-90">
              <div>{intl.formatMessage(eventFaqDefinition.av_music.provided_av_equipment[equipment])}</div>
              {faqData[equipment].description && <ReadMoreText
                text={faqData[equipment].description}
                linesToDisplay={2}
                textClass="text-gray-600 description text-small"
                linkStyling="text-gray-600 text-small"
              />}
            </div>
          </div>))
        }
      </div>
    </div>
  );
};

AVMusicExpanded.propTypes = {
  faqData: PropTypes.object,
  availableEquipment: PropTypes.array,
  intl: PropTypes.object
};

export default injectIntl(AVMusicExpanded);
